import { DataType } from "../../../../form/typings";
export default {
    $id: "description",
    type: DataType.Object,
    properties: {
        name: {
            type: DataType.String,
            title: "控件名称",
        },
        dataItemType: {
            type: DataType.String,
            title: "数据项类型",
        },
        displayFormula: {
            type: DataType.String,
            title: "显示条件",
        },
    },
};
